import apiBase from "../../api/axios";

const BASE = "v1/talentos-plantel";

/**
 * Obtiene las conversaciones del plantel para los selectores.
 * GET /api/v1/talentos-plantel/selectores/conversaciones/?plantel={id}
 */
export const getConversacionesSelectoresPlantelService = async (plantelId) => {
  const response = await apiBase.get(`${BASE}/selectores/conversaciones/`, {
    params: { plantel: plantelId },
  });
  return response.data;
};

/**
 * Obtiene la configuración existente para un talento en un plantel,
 * agrupada por conversación.
 * GET /api/v1/talentos-plantel/configuraciones-conducir/por-talento/
 *   ?talento={talentoId}&plantel={plantelId}
 */
export const getConfiguracionPorTalentoPlantelService = async (plantelId, talentoId) => {
  const response = await apiBase.get(
    `${BASE}/configuraciones-conducir/por-talento/`,
    {
      params: { plantel: plantelId, talento: talentoId },
    }
  );
  return response.data;
};

/**
 * Crea o actualiza todas las configuraciones de conversación para un talento
 * en un plantel.
 * POST /api/v1/talentos-plantel/configuraciones-conducir/crear-por-talento/
 */
export const crearConfiguracionPorTalentoPlantelService = async (payload) => {
  const response = await apiBase.post(
    `${BASE}/configuraciones-conducir/crear-por-talento/`,
    payload
  );
  return response.data;
};
